import { CompanyBetaProgramsTabBaseDataProvider } from './CompanyBetaProgramsTabBaseDataProvider';
import { GetBetaProgramsResponse, UpdateEnrollmentStateResponse } from '../types/types';

export class CompanyBetaProgramsTabGzDataProvider extends CompanyBetaProgramsTabBaseDataProvider {
  async getAllAvailableBetaPrograms(): Promise<GetBetaProgramsResponse> {
    return await this.dependencies.api.clients.BetaPrograms.GetAllAvailableBetaPrograms().toPromise();
  }

  async updateEnrollmentState(type: number, state: boolean): Promise<UpdateEnrollmentStateResponse> {
    return await this.dependencies.api.clients.BetaPrograms.UpdateEnrollmentState(type, state).toPromise();
  }

  async clearSessionsForUsersInCurrentCompany() {
    await this.dependencies.api.clients.Users.ClearSessionsForUsersInCurrentCompany().toPromise();
  }
}
